import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import {ICheckoutStep} from '../../../../i';

interface IHeaderProps {
    isMobile: boolean;
    collapseId: string;
    hasItems: boolean;
}

const Header = observer(({isMobile, collapseId, hasItems}: IHeaderProps) => {
    return (
        <div
            className={isMobile ? 'cs-header pointer' : 'cs-header'}
            {...(hasItems && {'aria-controls': collapseId})}
        >
            {!isMobile ? 'Order Summary' : 'Order Summary'}
            {!isMobile && store.checkout.cstep !== ICheckoutStep.cart && !store.uiCheckout.processing && (
                <button
                    className="cs-edit link text-btn text-uppercase b"
                    type="button"
                    onClick={() => store.moveStep(ICheckoutStep.cart)}
                    aria-label="Back to cart"
                >
                    Back to Cart
                </button>
            )}
        </div>
    );
});

export default Header;
